import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import './styles.scss';

const microsoftLogo = 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg';

const FakeMicrosoftButton = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        className="fake-microsoft-button"
        onClick={handleOpen}
        fullWidth
      >
        <img
          src={microsoftLogo}
          alt="Microsoft logo"
          className="fake-microsoft-button__logo"
        />
        Sign in with Microsoft
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Feature Unavailable</DialogTitle>
        <DialogContent>
          <Typography>Contact Sixfactor to Inquire about this feature.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FakeMicrosoftButton;
